import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "./CreateGroupModal.css";
import api from "../../api/apiClient";
import { toast } from "react-toastify";

const ActionModal = ({
  show,
  handleClose,
  actionType,
  selectedRole,
  selectedUser,
  setSelectedRole,
  setSelectedUser,
  users = [],
  selectedNodes = [],
}) => {

  const handlePermissions = async (tag) => {
    const selectedUserData = users.find((user) => user.email === selectedUser);

    if (!selectedUserData) {
      toast.error("Selected user not found.");
      return;
    }

    const exportedInstances = selectedNodes.map(
      (selectedNode) => selectedNode.node.props.name
    );
    const exportedClasses = selectedNodes.map(
      (selectedNode) => selectedNode.node.class
    );

    try {
      const response = await api.post("/domain-data/", {
        user_id: selectedUserData.id,
        exported_instances: exportedInstances,
        role: selectedRole,
        exported_classes: exportedClasses,
        tag: tag,
      });

      if (response && response.data.success) {
        toast.success(
          `${actionType === "restrict" ? "Restriction" : "Permission"} for ${selectedUser} was successful.`
        );
        handleClose();
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(
          `${actionType === "restrict" ? "Restriction" : "Permission"} failed. Please try again.`
        );
      } else if (error.request) {
        console.error("No response received:", error.request);
        alert("No response from server. Please try again later.");
      } else {
        console.error("Error:", error.message);
        alert(`Error occurred: ${error.message}`);
      }
    }
  };

  const filteredUsers = users.filter(
    (user) => user.is_staff === selectedRole && user.is_active
  );

  return (
    <Modal show={show} onHide={handleClose} className="create-export-modal">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "18px" }}>
          {actionType === "restrict" ? "Restrict User" : "Allow User"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <p>Select Role</p>
          <Form.Control
            as="select"
            className="mb-3"
            value={selectedRole}
            onChange={(e) => setSelectedRole(e.target.value)}
          >
            <option value="">Select Role</option>
            <option value="Viewer">Viewer</option>
            <option value="Editor">Editor</option>
          </Form.Control>

          <p>Select User</p>
          <Form.Control
            as="select"
            className="mb-3"
            value={selectedUser}
            onChange={(e) => setSelectedUser(e.target.value)}
          >
            <option value="">Select User</option>
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <option key={user.email} value={user.email}>
                  {user.email}
                </option>
              ))
            ) : (
              <option>No users available</option>
            )}
          </Form.Control>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={() =>
            handlePermissions(actionType === "restrict" ? "restrict" : "allow")
          }
          className="create-button"
        >
          {actionType === "restrict" ? "Restrict" : "Allow"}
        </Button>
        <Button
          variant="secondary"
          onClick={handleClose}
          className="cancell-button cancell-button-container"
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ActionModal;
